import { render } from "./AccordionPane.vue?vue&type=template&id=22255fa2&scoped=true&ts=true"
import script from "./AccordionPane.vue?vue&type=script&lang=ts"
export * from "./AccordionPane.vue?vue&type=script&lang=ts"

import "./AccordionPane.vue?vue&type=style&index=0&id=22255fa2&scoped=true&lang=css"

import exportComponent from "/home/runner/work/attack-flow/attack-flow/src/attack_flow_builder/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22255fa2"]])

export default __exports__